module.exports = __webpack_public_path__ + "2598531847b6654ee5d5e4f58e921118.png";